module.exports = __webpack_public_path__ + "img/massage.fcf94845.png";